import { WebGLRenderer } from "three";
import { detectFromBrowser, settingsForTier } from "./tier";

export function createRenderer(canvas: HTMLCanvasElement): WebGLRenderer {
  const tier = detectFromBrowser();
  const settings = settingsForTier(tier);

  const renderer = new WebGLRenderer({
    canvas,
    antialias: tier !== "low",
    powerPreference: "high-performance",
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, settings.pixelRatioCap));
  renderer.setSize(window.innerWidth, window.innerHeight, false);
  renderer.setClearColor(0x05070b, 1);

  window.addEventListener("resize", () => {
    renderer.setSize(window.innerWidth, window.innerHeight, false);
  });

  return renderer;
}
